import { render, staticRenderFns } from "./TableProList.vue?vue&type=template&id=e8a906e4&scoped=true"
import script from "./TableProList.vue?vue&type=script&lang=js"
export * from "./TableProList.vue?vue&type=script&lang=js"
import style0 from "./TableProList.vue?vue&type=style&index=0&id=e8a906e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a906e4",
  null
  
)

export default component.exports